import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react'
import { ArrowUpIcon } from 'lucide-react'
import { match } from 'ts-pattern'
import useViewModel from './ThermostatSuggestionCard.viewmodel'
import { toTitleCase } from '@/utils/string'
import { Text } from '@/components'

export function CostCategoryIcon(props: {
  type: 'negative' | 'low' | 'medium' | 'high'
}) {
  const size = 16
  const icon = match(props.type)
    .with('negative', () => (
      <ArrowDownIcon size={size} className="text-base-green-900" />
    ))
    .with('low', () => (
      <ArrowDownIcon size={size} className="text-base-green-700" />
    ))
    .with('medium', () => (
      <ArrowRightIcon size={size} className="text-base-orange-500" />
    ))
    .with('high', () => (
      <ArrowUpIcon size={size} className="text-base-red-500" />
    ))
    .exhaustive()

  return icon
}

export function CostCategoryPreviewRow(props: {
  type: 'negative' | 'low' | 'medium' | 'high'
  costCategories: ReturnType<typeof useViewModel>['costCategories']
}) {
  const costCategory = props.costCategories.find(
    (category) => category.type === props.type,
  )

  if (!costCategory) {
    return null
  }

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-row items-center">
        <CostCategoryIcon type={props.type} />
        <Text variant="body3" className="ml-2 font-bold text-themed-grey-500">
          {toTitleCase(props.type)} Cost Hour
        </Text>
      </div>
      <Text
        variant="body3"
        className="text-themed-grey-500 text-[12px] font-medium"
      >
        Shift by {costCategory?.initValue}°
      </Text>
    </div>
  )
}
